import store from "../../../store/store";
export default class AnalysisHelpers {
  static buildQueryLayers(
    axis,
    preselectOverrides = null,
    preselectOverridesWhenModifiersEmpty = null
  ) {
    let r = [];

    if (!axis.levels.length || !axis.levels[0].layers.length) {
      return r;
    }

    axis.levels.forEach(level => {
      let obj = {
        layers: [],
        preselect: {
          connect: level.linked,
          includeAll: level.includeAll,
          perGroup: level.grouped,
          max: level.max
        }
      };

      if (
        typeof preselectOverrides === "object" &&
        preselectOverrides !== null
      ) {
        obj.preselect = {
          ...obj.preselect,
          ...preselectOverrides
        };
      }

      if (
        preselectOverridesWhenModifiersEmpty &&
        level.modifiers.length === 0
      ) {
        obj.preselect = {
          ...obj.preselect,
          ...preselectOverridesWhenModifiersEmpty
        };
      }

      level.modifiers.forEach(lm => {
        obj.preselect[lm.operator] = lm.value;
      });
      level.layers.forEach(ll => {
        //if(ll.value.includes("filt") || ll.value.includes("invalid")){
        //  obj.layers = obj.layers.concat(this.getFilterLayers(ll.value)).lenght>0? obj.layers.concat(this.getFilterLayers(ll.value)):obj.layers;
        //}
        //else{
          obj.layers.push(ll.value);
        //}
      });

      r.push(obj);
    });

    return r;
  }
  static getFilterLayers(filtId){
    let layers = [];
    store.state.filter.filters.forEach(cat => {
      if(cat._id === filtId){
        cat.children.forEach(sub => {
          sub.children.forEach(filt => {
            layers = layers.concat(this.getFilterConcepts(filt))
          })
        })
      }
      else{
        cat.children.forEach(sub => {
          if(sub._id === filtId){
            sub.children.forEach(filt => {
              layers = layers.concat(this.getFilterConcepts(filt))
            })
          }
          else{
            sub.children.forEach(filt => {
              if(filt._id === filtId){
                layers = layers.concat(this.getFilterConcepts(filt))
              }
            })
          }
        })
      }
    });
    return layers
  }

  static getFilterConcepts(filt){
    let concepts = [];
    filt.rawquery.forEach(item => {
      if(typeof item !== "string" && item._id !== "TTC_XXX"){
        concepts.push(item._id);
      }
    })
    return concepts;
  }
}
